exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "\n.load-wrapper[data-v-24a16d5c] {\n  -webkit-box-flex: 10;\n      -ms-flex-positive: 10;\n          flex-grow: 10;\n}\n", ""]);

